<loading-contents *ngIf="websites == null || photos == null"></loading-contents>
<div class="main-container" *ngIf="websites != null && photos != null">
    <app-slider></app-slider>
    <div class="top-contents padding-top-30">
        <div class="container">
            <p style="white-space: pre-line;">{{ intro }}</p>
        </div>
    </div>
    <div class="website padding-top-30">
        <div class="container">
            <h2 class="main-title padding-bottom-15"><span class="taiji-icon"></span> View My Works</h2>
            <div class="row" *ngIf="websites">
                <div class="col-lg-12 title padding-bottom-15">
                    <h5>Web Development</h5>
                </div>
                <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6" (click)="onSelect(website)"  *ngFor="let website of websites">
                    <div class="card">
                        <div class="card-image">
                        <img src="../../assets/images/websites/thumbnail/{{website.thumbnail_image}}" class="card-img-top" alt="{{website.title}}">
                        </div>                            
                        <div class="card-body">
                        <div class="body-wrapper">                                
                            <div class="siteTitle">
                            <h6>{{website.title}}</h6>
                            <span>Build by: {{website.item_category}}</span>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="photos">
                <div class="col-lg-12 title padding-bottom-15">
                    <h5>Photography</h5>
                </div>
                <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6" (click)="onSelectPotography(item)"  *ngFor="let item of photos">
                    <div class="card">
                        <div class="card-image">
                        <img src="../../assets/images/photography/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                        </div>                            
                        <div class="card-body">
                        <div class="body-wrapper">                                
                            <div class="siteTitle">
                            <h6>{{item.title}}</h6>
                            <span>{{item.item_category}}</span>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="socail-media padding-top-30">
        <div class="container">
            <div class="row">
                <!-- <div class="col-lg-6 col-xs-6 col-md-6 col-sm-6">
                    <instagram-post></instagram-post>
                </div> -->
                <div class="col-lg-12 col-xs-12 col-md-12 col-sm-12">
                    <tumblr-posts></tumblr-posts>
                </div>
            </div>
        </div>
    </div>
</div>
